var React = require('react');

function IconInfographicInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13,0 C5.8136646,0 0,5.85403727 0,13 C0,20.1459627 5.8136646,26 13,26 C20.1863354,26 26,20.1863354 26,13 C26,5.8136646 20.1863354,0 13,0 Z M24.7888199,12.3944099 L13.6055901,12.3944099 L13.6055901,1.21118012 C19.621118,1.49378882 24.5062112,6.37888199 24.7888199,12.3944099 Z M12.3944099,11.5465839 L5.08695652,4.23913043 C7.02484472,2.46273292 9.56832298,1.33229814 12.3944099,1.21118012 L12.3944099,11.5465839 Z M4.23913043,5.08695652 L12.1521739,13 L4.23913043,20.9130435 C2.34161491,18.8136646 1.21118012,16.0279503 1.21118012,13 C1.21118012,9.97204969 2.34161491,7.1863354 4.23913043,5.08695652 Z"}));
}

IconInfographicInline.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = IconInfographicInline;

IconInfographicInline.default = IconInfographicInline;
